// Tipos de máquina do card "[PEDIDO] CRIAR CADASTRO DE MAQUINA" (21/08/2026).
//
// Lista FIXA no código, por decisão do usuário — o card dá lista fechada. Se um
// dia o cliente precisar acrescentar tipo SEM deploy, isto tem de virar tabela no
// banco, que é o padrão de Marca, Modelo e Grupo de Produto.
//
// Duas correções deliberadas em relação ao texto do card:
//
//   - o card lista "Cápsulas" ANTES de "Café Filtrado", o que não é ordem
//     alfabética em português ('Caf' < 'Cáp'), e o próprio card pede ordem
//     alfabética. Por isso a ordenação é por localeCompare e não pela ordem
//     escrita aqui: acrescentar opção no fim da lista não desarruma o combo.
//
//   - o card escreve "Líquidificadores", com acento a mais. O certo é
//     "Liquidificadores".
//
// ATENÇÃO: o valor gravado é o próprio texto (como OPTIONS_FINALITY faz com
// 'Locação'), então renomear um rótulo aqui deixa as máquinas já cadastradas
// apontando para um tipo que não existe mais na lista.
const TIPOS_MAQUINA = [
  'Café Filtrado',
  'Cápsulas',
  'Garrafas Chantilly',
  'Lava Louças',
  'Liquidificadores',
  'Moedores',
  'Multi Bebidas',
  'Profissionais',
  'Super Automáticas',
  'Vaporizadores',
];

export const OPTIONS_TIPO_MAQUINA = [...TIPOS_MAQUINA]
  .sort((a, b) => a.localeCompare(b, 'pt-BR'))
  .map((tipo) => ({ value: tipo, label: tipo }));

// Para o FILTRO da tela de pesquisa. A primeira opção limpa o filtro, e o valor
// dela é vazio de propósito: a PROC_MAQUINA_LISTAR trata '' como "não filtrar".
// Mandar a palavra 'Todos' faria a proc procurar máquinas do tipo "Todos".
export const OPTIONS_TIPO_MAQUINA_FILTRO = [
  { value: '', label: 'Todos' },
  ...OPTIONS_TIPO_MAQUINA,
];
